export default __webpack_public_path__ + "931d67ea207ab37ee693ff155ff4d7a6.woff2";